export const CONST_SITE_TITLE = "Jeff's BattleTech Tools"

export const CONST_HIGHLIGHT_COLOR = "#0000AA"

export const CONST_BATTLETECH_URL = "https://bg.battletech.com";